
import { useEffect } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import AuthNavigation from "@/components/auth/AuthNavigation";
import AuthFeatures from "@/components/auth/AuthFeatures";
import AuthForm from "@/components/auth/AuthForm";

const Auth = () => {
  console.log("Auth component rendering");
  
  const { isAuthenticated, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    console.log("Auth useEffect - loading:", loading, "isAuthenticated:", isAuthenticated);
    
    // Only redirect if we're not loading and user is actually authenticated
    if (!loading && isAuthenticated) {
      console.log("User authenticated and not loading, redirecting to /app");
      navigate("/app", { replace: true });
    }
  }, [isAuthenticated, loading, navigate]);

  // Show loading state while authentication is being determined
  if (loading) {
    console.log("Auth component showing loading state");
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  // Only show auth form if user is not authenticated and not loading
  if (!isAuthenticated) {
    console.log("Auth component showing auth form");
    return (
      <div className="min-h-screen bg-gray-50">
        <AuthNavigation />

        <div className="container mx-auto px-4 py-12">
          <div className="grid lg:grid-cols-2 gap-12 items-start max-w-6xl mx-auto">
            <AuthFeatures />
            <AuthForm />
          </div>
        </div>
      </div>
    );
  }

  // This should rarely be reached since useEffect handles the redirect
  // But it's a fallback to prevent blank pages
  console.log("Auth component fallback - redirecting");
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <p className="text-gray-600">Redirecting...</p>
      </div>
    </div>
  );
};

export default Auth;
